import moment from 'moment';
export const INTEGRATION_NAME = 'google-meet';
export const DEFAULT_TOPIC = `Google Meet ${moment().toLocaleString()}`;
export const MEET_SDK_SESSION_STORAGE_KEY = 'meet_sdk';
export const ORIGIN_SESSION_STORAGE_KEY = 'origin';
export const AUTOMAPPED_PARTICIPANTS_EVENT_SENT_KEY = 'automappedParticipantsEventSent';
export const FAKE_MEETING_UUID_STORAGE_KEY = 'google-meet-meeting-uuid';
export const MEETING_UUID_DELIMITER = '~';
export const CLOUD_PROJECT_NUMBER = {
  qa: '848994733439',
  prod: '717327351646'
};